<template>
	<footer class="main">				
		&copy;  <b >Marquez Express Inc. EIN 47-3494431</b>
	</footer>
</template>

<script type="text/javascript">
	export default {
        mounted() {
            
        }
    }
</script>